<template lang="pug">
    .digital-edit__form
        SvButton.digital-edit__button-top(
            v-show="visibleToTop"
            :prependIcon=`{
                icon: 'arrow-up',
                width: 10,
                height: 15,
            }`
            view="flat"
            text="Наверх"
            @click="scrollToTop"
        )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Название

            .digital-edit__form-elements--medium
                SvInput(
                    v-model="name"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Символьный код

            .digital-edit__form-elements--small
                SvInput(
                    v-model="alias"
                    color="graylight"
                    :withIcon="false"
                )
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import SvCheckbox from '@/components/uikit/SvCheckbox.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvMap from '@/components/uikit/SvMap.vue';
import SvSelect from '@/components/uikit/SvSelect.vue';
import SvDatePicker from '@/components/uikit/SvDatePicker.vue';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvSelectList from '@/components/uikit/SvSelectList.vue';
import SvInputList from '@/components/uikit/SvInputList.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvSelectInputList from '@/components/uikit/SvSelectInputList.vue';
import SvDoubleInputList from '@/components/uikit/SvDoubleInputList.vue';
import {rusToLatin} from '@/helpers/transform';
import SvUpload from '@/components/uikit/SvUpload.vue';
import SvTextarea from '@/components/uikit/SvTextarea.vue';
import SvMultipleInputs from '@/components/uikit/SvMultipleInputs.vue';
import '@ckeditor/ckeditor5-build-classic/build/translations/ru';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SolutionEmpty from "@/components/forms/subforms/SolutionEmpty";
import SolutionForm from "@/components/forms/subforms/SolutionForm";

export default {
    name: 'FormDistrict',

    data() {
        return {
            geoVisible: false,
            visibleToTop: false,
        };
    },

    mounted() {
        window.addEventListener('scroll', () => {
            this.scrolled();
        });
    },

    computed: {
        ...mapGetters({
            current: 'districts/getCurrent',
        }),

        id: () => this.current.id,

        name: {
            get() {
                return this.current.name;
            },
            set(name) {
                this.setValue({name});
                this.setValue({alias: rusToLatin(name).toLowerCase()});
            },
        },

        alias: {
            get() {
                return this.current.alias;
            },
            set(alias) {
                this.setValue({alias});
            },
        },
    },

    methods: {
        ...mapMutations({
            setValue: 'districts/setValue',
        }),

        scrolled() {
            if (window.pageYOffset > 700) {
                this.visibleToTop = true;
            } else {
                this.visibleToTop = false;
            }
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },
    },

    components: {
        SvRadio,
        SvInput,
        SvButton,
    },
};
</script>

<style lang="scss">
.digital-edit__button-top {
    position: fixed;
    right: 50px;
    bottom: 50px;
    z-index: 999;
}

.digital-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.digital-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;

    &--start {
        align-items: flex-start;
    }
}

.digital-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.digital-edit__form-item_section-title {
    margin-top: 60px;
}

.digital-edit__form-item_section-title_section-title-first {
    margin-top: 10px;
}

.digital-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.digital-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.digital-edit__form {
    padding: 50px 0;
}

.digital-edit__form-radio {
    margin-right: 21px;
}

.digital-edit__form-separator {
    min-width: 70px;
    text-align: center;
}

.digital-edit__form-elements--medium {
    width: 495px;

    &.ext_features {
        .sv-input__wrapper {
            width: 100%;
        }

    }
}

.digital-edit__form-elements--flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.digital-edit__form-elements--grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px 40px;
    align-items: flex-start;
    margin-bottom: 10px;

    .sv-checkbox__content {
        white-space: nowrap;
    }
}


.digital-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.digital-edit__search {
    width: 47%;
    min-width: 280px;
}

.digital-edit__section-title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
}

.digital-edit-plans__form {
    display: grid;
    grid-template-columns: repeat(4, 260px);
    grid-gap: 30px;
    margin-top: 50px;
}

.mb20 {
    margin-bottom: 20px;
}
</style>
